import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "app",
    class: "min-h-screen bg-gray-50"
};
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const authStore = useAuthStore();
        onMounted(() => {
            // Initialize auth state from localStorage
            authStore.initializeAuth();
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_view)
            ]));
        };
    }
});
